import '../MetasGerais/MetasGerais.css'
import { useRef, useState } from 'react';
import { logout } from '../../auth';
import { post } from '../../services/api';
import imagemExemplo from '../../assets/img/imagemExemploCsvMercantilExtra.png';

import AdminSection from "../AdminSection/AdminSection";
import DownloadIcon from '@mui/icons-material/Download';

export default function MetasMercantil({ setNotifier }) {
  const [valorBase, setValorBase] = useState('');
  const [valorBaseCSVFileName, setValorBaseCSVFileName] = useState(undefined);
  const [valorBasePadrao, setValorBasePadrao] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const valorBaseCSVRef = useRef(undefined);
  const valorBasePadraoRef = useRef(undefined);

  function refreshInputs(type = 'all') {
    setValorBase('');
    setValorBaseCSVFileName(undefined);
    if (valorBaseCSVRef.current?.value != null) valorBaseCSVRef.current.value = null;
    setValorBasePadrao(0);
    if (valorBasePadraoRef.current?.checked != null) valorBasePadraoRef.current.checked = false;
  }

  function handleRefresh(e, type = 'all') {
    e.preventDefault();
    refreshInputs(type);
  }

  function isThirdStagePopuled() {
    const valorBaseNumber = Number(
      valorBase.replaceAll('.', '').replace(',', '.')
    );
    return (
      (!isNaN(valorBaseNumber) && valorBaseNumber !== 0) ||
      valorBaseCSVFileName !== undefined ||
      valorBasePadrao !== 0
    );
  }

  async function handleValorBaseSubmit(event) {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      const idUsuarioAtual = localStorage.getItem("idusuario");
      const authToken = localStorage.getItem("adminToken");
      if (!idUsuarioAtual) {
        logout();
        return;
      }

      const formData = new FormData();
      formData.append('idusuario', idUsuarioAtual);
      
      if (valorBaseCSVRef.current?.files?.[0]) {
        formData.append('valorBaseCSV', valorBaseCSVRef.current.files[0]);
      }

      const { response, data } = await post(
        '/admin/uploadMetasExtra/metas-mercantil',
        formData,
        authToken,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response?.status >= 400) {
        setNotifier(false, response.data || "Erro ao enviar arquivo");
      } else {
        setNotifier(true, 'Enviado com sucesso');
        refreshInputs();
      }
    } catch (error) {
      console.error("Erro ao enviar arquivo:", error);
      setNotifier(false, "Erro ao enviar arquivo. Verifique o console para mais detalhes.");
    } finally {
      setIsSubmitting(false);
    }
  }

  function baixarExemploCSV() {
    const csvData = [
      ['Cod Filial','Mes','Ano','Meta Ideal','Meta Desafio','Meta Orcada','PVE','Juros Orçado','Juros Desafio']
    ];
    const csvContent = csvData.map(e => e.join(";")).join("\n");
    const blob = new Blob(['\uFEFF'+csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'exemploMetasMercantil.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  return <>

  <AdminSection
        etapa={2} titulo={'Importar metas mercantil Extranet:'}
        
        acoes={<>
            <button type="button" className='download-btn' onClick={baixarExemploCSV}> <DownloadIcon style={{width: '25px', height: '25px', marginRight: '10px'}}/> Exportar modelo</button>
        </>}
        >
          <div className="texto-csv" style={{paddingTop: "30px"}}>
            <span className="bold-text">
              Exemplo a ser seguido:      
            </span>
          </div>

        <div className='imagemExemplo'>
            <img src={imagemExemplo} alt="Exemplo" /><br></br>
        </div>  
      <form onSubmit={handleValorBaseSubmit} encType="multipart/form-data">
        <div className='p-8' style={{paddingBottom: "16px"}}>
          <div className="texto-csv">
            <span className="bold-text">
              Importe seu arquivo clicando no botão abaixo
            </span>
            <div className="normal-text">
              O arquivo deve ser em formato CSV (separado por vírgulas).
            </div>
            <div className="bold-text" style={{ fontSize: '0.85rem' }}>
              *Somente é possível importar dados referentes ao mês atual ou ao mês anterior.
          </div>
          </div>
          <div className='importar-csv'>
            <label htmlFor="valorBaseCSVMercantil" className={`btn-label ${valorBase !== '' || valorBasePadrao !== 0 ? 'disabled' : ''}`}>
              Importar CSV
            </label>
            <input type="file" accept='.csv' ref={valorBaseCSVRef} name='valorBaseCSV' id="valorBaseCSVMercantil"
              onChange={(e) => {
                const uploadedFile = e.target.files[0];
                if (uploadedFile) setValorBaseCSVFileName(uploadedFile.name);
              }}
              disabled={valorBase !== '' || valorBasePadrao !== 0}
            />
            <label className='muda-nome'>
              {valorBaseCSVFileName || ''}
            </label>
          </div>
        </div>

        <div className='animal-valorBase-buttons' style={{textAlign: "center", padding: "0px"}}>
          <button className='animal-refresh-btn' onClick={(e) => handleRefresh(e, 'metaBase')}>
            Cancelar
          </button>
        </div>
    
          <div className="button-container" style={{justifyContent: 'flex-end'}}>
            <button type="submit" className='animal-save-btn' disabled={!isThirdStagePopuled() || isSubmitting}>
              {isSubmitting ? 'Enviando...' : 'Enviar CSV'}
            </button>
        </div>
      </form>
    </AdminSection>
  </>;
}